module.exports = __webpack_public_path__ + "img/courier-jpexpress.84734246.svg";